import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./Recipient.module.scss";
import { SonicTermData } from "../../../common/classes/SonicTerm";
import { useAppSelector } from "../../../redux/hooks";
import { getMeta, getRoles } from "../../../redux/reducers/user";
import SonicLink from "../../../common/routing/SonicLink";

type Props = {
  type?: string;
  user_name?: string;
  mail_address?: string;
  roles?: Array<string>;
  school?: SonicTermData;
  isSelect: boolean;
  link: string;
};

export const Sender: React.FC<Props> = (props) => {
  const { type, user_name, mail_address, roles, school, isSelect, link } =
    props;

  const title: string = type === "project" ? "応募者情報" : "オファー依頼者";

  const adminMeta = useAppSelector(getMeta);
  const adminRoles = useAppSelector(getRoles);

  // Decide whether to display the user detail link
  const checkViewPrivilege = () => {
    if (isSelect) {
      return true;
    }

    // sender is non-jikei user
    if (
      !(
        roles?.includes("jikei_admin") ||
        roles?.includes("jikei_manager") ||
        roles?.includes("jikei_student")
      )
    ) {
      return false;
    }

    // jikei_admin can view all students
    if (adminRoles?.includes("jikei_admin")) {
      return true;
    }

    // school outside jurisdiction
    if (adminMeta?.school?.id !== school?.id) {
      return false;
    }

    return true;
  };

  return (
    <div className={styles["f-sender"]}>
      <h2 className={styles["f-sender__title"]}>{title}</h2>
      <div className={`${styles["f-sender__content"]} ${styles["sender"]}`}>
        <div className={`${styles["f-sender__content-info"]}`}>
          <div>
            <p>会員名</p>
            <div>
              <span>{user_name}</span>
              {/* TODO Link to membership details page */}
              {checkViewPrivilege() === true ? (
                <SonicLink to={link} newTab={true}>
                  <FontAwesomeIcon icon={["fal", "external-link-alt"]} />
                  ユーザー詳細
                </SonicLink>
              ) : null}
            </div>
          </div>
          <div>
            <p>メールアドレス</p>
            <span>{mail_address}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sender;
